import { render, staticRenderFns } from "./Strategies.vue?vue&type=template&id=81815720&scoped=true"
import script from "./Strategies.vue?vue&type=script&lang=js"
export * from "./Strategies.vue?vue&type=script&lang=js"
import style0 from "./Strategies.vue?vue&type=style&index=0&id=81815720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81815720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout,VSpacer})
